import { JSON_FIELD_CONSTANTS } from '../../../integration-test-modal.constants';

export const jsonFieldUtils = {
  getDefaultValue: (isArray: boolean): unknown[] | Record<string, unknown> => {
    if (isArray) {
      return [];
    }
    return {};
  },

  getNormalizedArrayValue: (
    value: unknown,
    defaultValue: unknown[] | Record<string, unknown>
  ): unknown[] | Record<string, unknown> => {
    if (Array.isArray(value)) {
      return value;
    }
    return defaultValue;
  },

  getNormalizedObjectValue: (
    value: unknown,
    defaultValue: unknown[] | Record<string, unknown>
  ): unknown[] | Record<string, unknown> => {
    if (typeof value === 'object' && value !== null) {
      return value as Record<string, unknown>;
    }
    return defaultValue;
  },

  getStringifiedValue: (normalizedValue: unknown): string => {
    try {
      return JSON.stringify(normalizedValue, null, 2);
    } catch {
      return '';
    }
  },

  parseJSONValue: (localValue: string, fallbackValue: unknown): unknown => {
    try {
      return JSON.parse(localValue);
    } catch {
      return fallbackValue;
    }
  },

  getPlaceholderText: (isArray: boolean): string => {
    if (isArray) {
      return JSON_FIELD_CONSTANTS.ARRAY_PLACEHOLDER;
    }
    return JSON_FIELD_CONSTANTS.OBJECT_PLACEHOLDER;
  },

  getHelperText: (isArray: boolean): string => {
    if (isArray) {
      return JSON_FIELD_CONSTANTS.ARRAY_HELPER_TEXT;
    }
    return JSON_FIELD_CONSTANTS.OBJECT_HELPER_TEXT;
  }
};
